import { materialType } from "./useProductIntervalForm"

export const mapAddedToTicketMaterials = (materials: materialType[] = []) => {
    return materials?.filter(el => !!el.using_ids?.[0]).map((el) => ({ stock_using_material_id: el.using_ids?.[0], count: el.local_count }))
}